import { supabase } from "@/lib/supabase";

export default function LogoutButton() {
  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      window.location.href = "/login"; // Redirect to login page after logout
    } catch (err) {
      console.error("Logout error:", err);
    }
  };
  return (
    <button
      onClick={handleLogout}
      className="py-2 px-4 rounded-md no-underline bg-btn-background hover:bg-btn-background-hover"
    >
      Logout
    </button>
  );
}
